export const iconFontAwesomeBuildingsHouseChimneyCrack = (
	<i className="fa-solid fa-house-chimney-crack"></i>
);
